import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray, FormBuilder } from '@angular/forms';
import { AuthservicesService } from 'src/app/services/authservices.service';

@Component({
  selector: 'app-campus-greeting',
  templateUrl: './campus-greeting.component.html',
  styleUrls: ['./campus-greeting.component.css']
})
export class CampusGreetingComponent implements OnInit {
  mytime
  greetingTitle = 'Welcome to our Ministry!'
  allRanges
  form: FormGroup;
  days: FormArray
  submitted = true
  iswelcomeMessage:any
  constructor(private fb: FormBuilder, private authService: AuthservicesService) { }
  arr = [

    {
      day: 'Monday',
      isSelected: true,
      is24Hours: true
    },
    {
      day: 'Tuesday',
      isSelected: true,
      is24Hours: true
    },
    {
      day: 'Wednesday',
      isSelected: true,
      is24Hours: true
    },
    {
      day: 'Thursday',
      isSelected: true,
      is24Hours: true
    },
    {
      day: 'Friday',
      isSelected: true,
      is24Hours: true
    },
    {
      day: 'Saturday',
      isSelected: true,
      is24Hours: true
    },
    {
      day: 'Sunday',
      isSelected: true,
      is24Hours: true
    },

  ]
  ngOnInit(): void {
    this.getCampusGreeting()
    this.form = this.fb.group({
      iswelcomeMessage: true,
      welcomeMessages: ['', { disabled: false }],
      radius: [0],
      days: new FormArray([])
    });
    for (let i = 0; i < 7; ++i) {

      this.createItem(this.arr[i]);
    }

    console.log(this.form.controls)

  }
  get f() {
    return this.form.controls;
  }
  get item() {
    return (<FormArray>this.form.controls['days']);
  }

  createItem(props) {
    this.item.push(this.fb.group({
      dayName: [props.day],
      isDaysSelected: [props.isSelected],
      is24Hours: [props.is24Hours],
      StartTime: [{ value: null, disabled: props.is24Hours }],
      EndTime: [{ value: null, disabled: props.is24Hours }]
    }))



  }
  setRange() {
    this.allRanges = document.querySelectorAll('.range-wrap')
    this.allRanges.forEach(e => {
      const range = e.querySelector(".custom-range");
      const bubble = e.querySelector(".bubble");

      this.setBubble(range, bubble)
    })

  }
  setBubble(range, bubble) {
    const val = range.value;
    const min = range.min ? range.min : 0;
    const max = range.max ? range.max : 100;
    const newVal = Number(((val - min) * 100) / (max - min));
    bubble.innerHTML = val;
    bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
  }


  onChange(event, key, i) {

    if (!event.target.checked && key == 'hours') {
      this.arr[i].is24Hours = false
    }
    else if (event.target.checked && key == 'hours') {
      this.arr[i].is24Hours = true
    }
  }


  getCampusGreeting() {
    this.authService.getcampusGreeting().subscribe((res: any) => {
      let data = res['data']
      let objtest = Object.keys(data).length === 0;
      if (!objtest) {
        const CONTROL = this.form.controls;

        for (const props in CONTROL) {
          CONTROL[props].patchValue(data[props]);
        }
      }
    },
      error => {
        console.log(error)
      })
  }


  onSubmit() {
    this.submitted = true;
    if (this.form.invalid) {
      this.authService.scrollToError();
      return;
    }

    this.authService.campusGreeting(this.form.value).subscribe((res: any) => {
      this.authService.successMessage(res.message, 'success').then((res) => {
        if (res.value) {
          this.getCampusGreeting()
        }
      })
    },
      error => {
        this.authService.successMessage(error.error.message, 'error')
      })
  }

  isWelcomeMessage(event: any) {
    if (event.target.checked) {
      this.iswelcomeMessage = true;
      this.form.controls['welcomeMessages'].disable();
    } else {
      this.iswelcomeMessage = false;
      this.form.controls['welcomeMessages'].enable();
    }
  }
}
